import {
  Box,
  FormControl,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import { TooltipWithIconCustom } from "./tooltip-custom";



export const DropdownSimple = ({
  title,
  list,
  value,
  setValue,
  tooltip,
  name
}) => {

  const handleChange = (e) => {
    setValue(e.target.value);
  };


  return (
    <FormControl
      /* error={!!error} */
      /* variant="standard" */
      sx={{ width: "100%" }}
    >
      <Box sx={{ width: "100%", display: "flex", flexDirection: "column" }}>
        <Box
          sx={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "2px",
            mb: "4px",
            padding: "0px 0px 0px 8px",
          }}
        >
          <TooltipWithIconCustom text={tooltip} >
            <Typography
              sx={{
                fontSize: "14px",
                color: "#343745",
                fontWeight: 500,
                lineHeight: 1.9,
              }}
            >
              {title}
            </Typography>
          </TooltipWithIconCustom>
        </Box>

        <Select
          value={value}
          onChange={handleChange}
          name={name}
          size="small"
          sx={{
            fontSize: "14px",
            "& .MuiSelect-select": {
              padding: "8.5px 8px",
            },
            "&.MuiInputBase-root": {
              borderRadius: "4px",
              background: "#fff",
            },
            "&.MuiOutlinedInput-root": {
              "& fieldset": {
                borderColor: "#dbdbeb",
                borderWidth: "1px",
                transition:
                  "border-color 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
              },
              "&:hover fieldset": {
                borderColor: "#efa21e",
                borderWidth: "1px",
              },
              "&.Mui-focused fieldset": {
                borderColor: "#efa21e",
                borderWidth: "1px",
              },
            },
          }}
        >
          {list.map((item) => (
            <MenuItem
              key={item.id}
              value={item.id}
            >
              {item.value}
            </MenuItem>
          ))}
        </Select>
      </Box>
    </FormControl>
  );
};
